
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 1.188c-1.09 0-1.944.847-1.944 1.859S4.91 4.907 6 4.907s1.944-.848 1.944-1.86S7.09 1.187 6 1.187zM3.18 3.046C3.18 1.522 4.459.312 6 .312c1.542 0 2.82 1.21 2.82 2.735S7.541 5.78 6 5.78c-1.542 0-2.82-1.21-2.82-2.734zm4.375 4.685a9.557 9.557 0 00-3.11 0l-.122.02-.07-.432.07.432c-1.124.185-1.969 1.192-1.969 2.396 0 .38.295.665.629.665h6.034c.334 0 .629-.284.629-.665 0-1.204-.845-2.211-1.97-2.396l.072-.432-.072.432-.12-.02zm.143-.864l-.072.432.072-.432.12.02c1.568.259 2.703 1.649 2.703 3.26 0 .837-.66 1.54-1.504 1.54H2.983c-.844 0-1.504-.703-1.504-1.54 0-1.611 1.135-3.001 2.702-3.26l.121-.02.072.432-.072-.432a10.43 10.43 0 013.396 0z","fill":"#fff"}})])
          )
        }
      }
    